
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { SectionTitle } from "@/components/section-title";

export function Contact() {
    return (
        <section id="contato" className="grid gap-8 scroll-mt-28">
            <SectionTitle
                eyebrow="Contato"
                title="Vamos construir juntos"
                subtitle="Entre em contato agora e desenhe a próxima fase do seu negócio com Inteligência Artificial."
            />

            <div className="max-w-2xl mx-auto w-full rounded-2xl border border-slate-200 dark:border-white/10 bg-white dark:bg-white/5 p-8 shadow-sm dark:shadow-none backdrop-blur">
                <form action="https://formspree.io/f/mdazddjl" method="POST" className="grid gap-6">
                    <div className="grid md:grid-cols-2 gap-4">
                        <div className="grid gap-2">
                            <Label htmlFor="name" className="text-slate-700 dark:text-slate-200">Nome</Label>
                            <Input id="name" name="name" placeholder="Seu nome" required className="bg-slate-100 dark:bg-black/20 border-slate-200 dark:border-white/10 text-slate-900 dark:text-white placeholder:text-slate-400 dark:placeholder:text-slate-500 focus-visible:ring-cyan-500" />
                        </div>
                        <div className="grid gap-2">
                            <Label htmlFor="email" className="text-slate-700 dark:text-slate-200">Email</Label>
                            <Input id="email" name="email" type="email" placeholder="seu@email.com" required className="bg-slate-100 dark:bg-black/20 border-slate-200 dark:border-white/10 text-slate-900 dark:text-white placeholder:text-slate-400 dark:placeholder:text-slate-500 focus-visible:ring-cyan-500" />
                        </div>
                    </div>

                    <div className="grid gap-2">
                        <Label htmlFor="company" className="text-slate-700 dark:text-slate-200">Empresa</Label>
                        <Input id="company" name="company" placeholder="Nome da sua empresa" className="bg-slate-100 dark:bg-black/20 border-slate-200 dark:border-white/10 text-slate-900 dark:text-white placeholder:text-slate-400 dark:placeholder:text-slate-500 focus-visible:ring-cyan-500" />
                    </div>

                    <div className="grid gap-2">
                        <Label htmlFor="message" className="text-slate-700 dark:text-slate-200">Mensagem</Label>
                        <Textarea id="message" name="message" placeholder="Como podemos ajudar?" required className="min-h-[120px] bg-slate-100 dark:bg-black/20 border-slate-200 dark:border-white/10 text-slate-900 dark:text-white placeholder:text-slate-400 dark:placeholder:text-slate-500 focus-visible:ring-cyan-500" />
                    </div>

                    <Button type="submit" className="w-full bg-gradient-to-r from-cyan-400 to-blue-500 text-slate-950 font-bold py-6 text-lg shadow-[0_0_20px_rgba(6,182,212,0.2)] hover:shadow-[0_0_30px_rgba(6,182,212,0.3)] transition-all">
                        Enviar Mensagem
                    </Button>
                </form>
            </div>
        </section>
    );
}
